module.exports = __webpack_public_path__ + "2f25df2504c5c3b57dbe90cca0cd9038.png";